import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useIdentityChallengeContext } from 'Context/IdentityChallengeContext';
import {
  FDDialogContent, FDPrimaryActionButton, FDStack, FDDialogActions,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import BackToChallengeButtonPicker from './BackToChallengeButtonPicker';


function CancelConfirmationLayout() {
  const { resource } = useMetaLayoutContext();
  const { handleClose } = useIdentityChallengeContext();

  return (
    <>
      <MetaControlField attr={'title'} />
      <FDDialogContent>
        <FDStack direction={'column'} justifyContent={'center'} alignItems={'stretch'} spacing={2}>
          <MetaControlField attr={'primaryText'} />
        </FDStack>
      </FDDialogContent>
      <FDDialogActions>
        <BackToChallengeButtonPicker />
        <FDPrimaryActionButton label={resource.attr('cancelButtonText')} onClick={handleClose} />
      </FDDialogActions>
    </>
  );
}

CancelConfirmationLayout.propTypes = {
};

CancelConfirmationLayout.defaultProps = {
};

export default CancelConfirmationLayout;
